import { render, staticRenderFns } from "./startedDialog.vue?vue&type=template&id=3dbbd0af&scoped=true"
import script from "./startedDialog.vue?vue&type=script&lang=js"
export * from "./startedDialog.vue?vue&type=script&lang=js"
import style0 from "./startedDialog.vue?vue&type=style&index=0&id=3dbbd0af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbbd0af",
  null
  
)

export default component.exports